export var checkIsAvailableAmenities = function (segment) {
    var _a, _b;
    var hasAmenities = ((_b = (_a = segment === null || segment === void 0 ? void 0 : segment.flightInfo) === null || _a === void 0 ? void 0 : _a.amenities) === null || _b === void 0 ? void 0 : _b.length) > 0;
    return hasAmenities && isCarrierTheSame(segment);
};
export var isCarrierTheSame = function (segment) { var _a, _b; return ((_a = segment.operatingAirline) === null || _a === void 0 ? void 0 : _a.iata) === ((_b = segment.marketingAirline) === null || _b === void 0 ? void 0 : _b.iata); };
